import AtomicTeam from "../../../../src/courses/partials/atomic/team.mdx";
import * as React from 'react';
export default {
  AtomicTeam,
  React
};